import { useEffect } from 'react'
import _get from 'lodash/get'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import { URL_HOME, URL_PLAYLIST_WATCH_LATER } from '../../services/url/constants'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import { handleRedirect } from './utils'

function GoCreatePlaylistRest (props) {
  const {
    createCustomPlaylistFromDeeplink,
    setOverlayDialogVisible,
    location,
    history,
    user,
    auth,
  } = props

  const isLoggedIn = getAuthIsLoggedIn(auth)
  const playlistCreate = _get(location, ['query', 'playlistCreate'])
  const contentIds = _get(location, ['query', 'contentIds'])

  const handleCreatePlaylist = () => {
    if (playlistCreate && contentIds) {
      createCustomPlaylistFromDeeplink({ name: playlistCreate, contentIds })
      handleRedirect({
        history,
        auth,
        user,
        url: URL_PLAYLIST_WATCH_LATER,
      })
    } else {
      handleRedirect({
        history,
        auth,
        user,
        url: URL_HOME,
      })
    }
  }

  useEffect(() => {
    if (!isLoggedIn) {
      setOverlayDialogVisible(TYPE_LOGIN)
    } else {
      handleCreatePlaylist()
    }
  }, [isLoggedIn])

  return null
}

GoCreatePlaylistRest.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  createCustomPlaylistFromDeeplink: PropTypes.func.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    createCustomPlaylistFromDeeplink: actions.playlist.createCustomPlaylistFromDeeplink,
    setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
  }
})(GoCreatePlaylistRest)
